<template>
<Teleport to="#modal-portal-target">
<div v-if="$store.getters['common/modalName'] === 'listreservations'">
    <div class="modal-header">
        <h3 class="modal-title">
            {{ product.name }} - {{ $_locale('reservation') }}
        </h3>
    </div>
    <div class="modal-body reservation-modal">
        <reservations-list v-bind:reservation="activeReservation"></reservations-list>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default pull-left" @click="$store.commit('common/setModal', null)">
            {{ $_locale('close') }}
        </button>
    </div>
</div>
</Teleport>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
    }),
    computed: {
        ...mapGetters({
            product: 'ecom/product',
            activeReservation: 'calendar/activeReservation',
        }),
    },
}
</script>